import { render } from "./EditGroupDialog.vue?vue&type=template&id=82898f52"
import script from "./EditGroupDialog.vue?vue&type=script&lang=js"
export * from "./EditGroupDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__